<script>
export default {
    name: 'RatingStars',
    functional: true,
    props: {
        rating: { type: [Number, String], required: true },
        size: { type: String, default: 'sm' },
        decorative: { type: Boolean, default: false },
        reviewCount: { type: [Number, String], default: null },
    },
    render(h, { props }) {
        const parsed = parseFloat(props.rating);
        if (!isFinite(parsed) || parsed <= 0) return null;
        const rounded = Math.round(parsed * 2) / 2;
        const sizeAliases = { small: 'sm', med: 'md', large: 'lg' };
        const size = sizeAliases[props.size] || props.size;
        const stars = h('span', { class: 'star__wrapper' },
            Array(5).fill(null).map(() => h('i', { attrs: { 'aria-hidden': 'true' } }))
        );

        if (props.decorative) {
            return h('span', {
                class: ['star__ratings', `star__ratings--${size}`],
                attrs: { 'data-rating': rounded, 'aria-hidden': 'true' },
            }, [stars]);
        }

        const count = props.reviewCount !== null ? parseInt(props.reviewCount) : null;
        let text = `Rated ${rounded} out of 5 stars`;
        if (count) text += ` based on ${count} ${count === 1 ? 'review' : 'reviews'}`;

        return h('span', {
            class: ['star__ratings', `star__ratings--${size}`],
            attrs: { 'data-rating': rounded },
        }, [
            h('span', { class: 'rating__text' }, [text]),
            stars,
        ]);
    },
};
</script>
